import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import Image from 'next/image';

import { TopicText } from '@/app/(main)/(pages)/(home)/_components/topic-text.component';
import aboutUsWomanSvg from '@/assets/about-us-woman.svg?url';
import { ContentContainer } from '@/components/ui/content-container.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

export const BrandValues = () => {
  return (
    <section className="relative overflow-hidden">
      <div className="bg-green-50 border-green-100 border-2">
        <ContentContainer className="pt-10 md:pt-10 relative z-10">
          <div className="text-center md:text-start mx-4 md:mx-0 mb-10">
            <div className="md:hidden">
              <Typography
                data-testid={DataTestIdEnum.BRANDING_VALUES_TITLE}
                variant={TypographyVariant.LARGE_SUBTITLE}
                className="font-bold mb-3"
              >
                Há mais de 25 anos a Medprev facilita seu acesso à saúde
              </Typography>
            </div>
            <div className="hidden md:block">
              <Typography
                data-testid={DataTestIdEnum.BRANDING_VALUES_TITLE}
                variant={TypographyVariant.LARGE_SUBTITLE}
                className="font-bold mb-3"
              >
                Há mais de 25 anos
                {' '}
                <br />
                a Medprev facilita seu acesso à saúde
              </Typography>
            </div>
            <p data-testid={DataTestIdEnum.BRANDING_VALUES_DESCRIPTION} className="text-gray-800 md:min-w-80 pb-8 md:pb-5">
              O princípio é simples: pague somente pelo serviço utilizado, sempre que precisar.
            </p>
          </div>
        </ContentContainer>
      </div>

      <ContentContainer className="relative z-10 md:flex justify-between md:pb-10">
        <div className="w-full">
          <div className="flex-col md:flex-row md:pt-4 md:gap-10 md:flex md:pb-12 md:flex-wrap md:max-w-lg">
            <TopicText
              className="items-center md:items-start pb-8 md:pb-0 md:min-w-48"
              title="+100"
              description="unidades físicas"
              index
            />
            <TopicText
              className="items-center md:items-start pb-8 md:pb-0 max-w-40 mx-auto md:mx-0"
              title="+3 mil"
              description="clínicas e postos de coleta de exames"
              index
            />
            <TopicText
              className="lg:max-w-8 xl:max-w-full items-center md:items-start pb-8 md:pb-0 md:min-w-48"
              title="+19 mil"
              description="profissionais parceiros"
              index
            />
            <TopicText
              className="items-center md:items-start pb-8 md:pb-0"
              title="+50 mil"
              description="agendamentos realizados"
              index
            />
          </div>

          <hr className="bg-gray-200 md:hidden" />
        </div>

        <div className="hidden xl:block relative min-w-72">
          <Image
            src={aboutUsWomanSvg}
            priority
            className="text-green-50 absolute -top-36"
            alt="Medprev"
            height={368}
            width={295}
          />
        </div>
      </ContentContainer>
    </section>
  );
};
